import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Icon from '../../misc/Icon';
import ThemeContext from '../../../theme/ThemeContext';

const StyledWrapper = styled.span`
  display: flex;
  align-items:center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 12px;
`;

const StyledTitleLabel = styled.label`
  font-weight: bold;
  font-size: 14px;
  margin-left: 4px;
  color: ${(props) => props.theme.fontColorPrimary}; 
`;

const StyledIconWrapper = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    font-size: 14px !important;
  }
`;

const FieldSettingsHeaderTitle = ({
  title,
  icon
}) => {

  const theme = useContext(ThemeContext);

  const iconNode = icon ? (
    <StyledIconWrapper>
      <Icon
        icon={icon}
        color={theme.fontColorPrimary}
      />
    </StyledIconWrapper>
  ) : null;

  return (
    <StyledWrapper>
      {iconNode}
      <StyledTitleLabel theme={theme}>
        {title}
      </StyledTitleLabel>
    </StyledWrapper>

  );

};

FieldSettingsHeaderTitle.propTypes = {
  title: PropTypes.string,
};

export default FieldSettingsHeaderTitle;
